import { combineReducers } from 'redux';
import {
    PACKAGES_FETCH_START,
    PACKAGES_FETCH_SUCCESS,
    PACKAGES_FETCH_ERROR,
    PACKAGE_CHECKOUT_INIT,
    PACKAGE_PAYMENT_FORM_SUBMIT,
    PACKAGE_PAYMENT_IS_PROCESSING,
    PACKAGE_PAYMENT_SUCCESS,
    PACKAGE_PAYMENT_ERROR,
    PACKAGE_CHECKOUT_ABANDON,
} from '../actions/types';

const packages = (state = [], action) => {
    switch (action.type) {
        case PACKAGES_FETCH_SUCCESS:
            return action.payload;
        case PACKAGES_FETCH_ERROR:
            return [];
        default:
            return state;
    }
};

const isLoading = (state = false, action) => {
    switch (action.type) {
        case PACKAGES_FETCH_START:
            return true;
        case PACKAGES_FETCH_SUCCESS:
        case PACKAGES_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case PACKAGES_FETCH_START:
        case PACKAGES_FETCH_SUCCESS:
            return null;
        case PACKAGES_FETCH_ERROR:
            return action.payload;
        default:
            return state;
    }
};

const purchaseError = (state = null, action) => {
    switch (action.type) {
        case PACKAGE_PAYMENT_FORM_SUBMIT:
        case PACKAGE_PAYMENT_SUCCESS:
        case PACKAGE_CHECKOUT_ABANDON:
            return null;
        case PACKAGE_PAYMENT_ERROR:
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    packages,
    isLoading,
    error,
    purchaseError,
});